import { utils } from "../../../../shop/frontend/web/js/utils";
import { googleAnalytics } from "../../../../shop/frontend/web/js/components/googleAnalytics";
import { saveUtmToCookie } from "../../../../shop/frontend/web/js/utils/utm";
import { hamburger } from "../../../../shop/frontend/web/js/components/hamburger";
import { Storage } from "./components/Storage";
import { helpers } from "../../../../shop/frontend/web/js/helpers";
import api from "../../../../shop/frontend/web/js/api";
import { QuantityCounter } from "../../../../shop/frontend/web/js/components/QuantityCounter";
import "swiper/swiper-bundle.css";
import Swiper, { Navigation } from "swiper";
import runFunctions from "@shop/frontend/web/js/shared/index.js";

Swiper.use([Navigation]);

export class App {
	constructor() {
		this.storage = new Storage();
		this.isDesktop = window.matchMedia("(min-width: 768px)");
	}

	init(params = {}) {
		utils.addVoidForLinks($("a"));

		hamburger("js-hamburger", "js-menu");

		if (window.gaEnabled) googleAnalytics();
		saveUtmToCookie();

		this.initFastRegistration();
		this.initToggleActiveClass();
		this.initCheckUserByEmailInput();
		this.initQuantityCounter();
		this.initTicketReturn();
		$(".news").length && this.initNews();

		window.storage = this.storage;
		if (params.CartService) CartService.getCount();

		this.setUpListeners();
		this.setUpModalListeners();
		this.setUpFormListeners();
		if ($("#js-access").length > 0) this.setUpAccessListeners();
		runFunctions();
	}

	setUpListeners() {
		const trigger = this.isDesktop.matches ? "hover" : "click";

		$('[data-toggle="tooltip"]').tooltip({
			trigger,
			template:
				'<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
		});

		if (this.isDesktop.matches) {
			$(document).on("scroll", function () {
				const $logo = $(".header__logo");
				if ($(this).scrollTop() > 5) {
					$logo.removeClass("start");
				} else {
					$logo.addClass("start");
				}
			});
		}

		$(document).on("click", "#js-hide-play-info", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".play-info");
			parent.remove();
		});

		$(document).on("mouseout", ".js-hover-out", e => {
			const element = $(e.currentTarget);
			element.blur();
		});

		$(".btn__info-icon").on("show.bs.tooltip", e => {
			if (this.isDesktop.matches) {
				$.each($("[data-toggle=tooltip]"), (i, item) => {
					if (e.target !== item) {
						$(item).tooltip("hide");
					}
				});
			}
		});

		$(document).on("click", ".js-hide-other-tooltip", e => {
			$.each($("[data-toggle=tooltip]"), (i, item) => {
				if (!item.classList.contains("js-hide-other-tooltip")) {
					$(item).tooltip("hide");
				}
			});
			e.stopPropagation();
		});

		$(document).on("click", ".js-order-button", e => {
			const element = $(e.currentTarget);
			const link = element.find(".order__button-link");
			if (!link.hasClass("is-quest")) window.location.assign(link.attr("href"));
		});
	}

	setUpFormListeners() {
		$(".enter form").on("submit", e => {
			const form = $(e.currentTarget);
			form.find("button[type='submit']").addClass("disabled");
		});

		$(".enter__input ").on("input", () => {
			$(".enter form button[type='submit']").removeClass("disabled");
		});

		$(".checkbox__input").on("keydown", e => {
			const element = $(e.currentTarget);

			if (e.code === "Enter" || e.code === "NumpadEnter") {
				element.toggleClass("checked");

				if ($(element).hasClass("checked")) {
					$(element).prop("checked", true);
				} else {
					$(element).prop("checked", false);
				}
			}
		});

		$(document).on("click", ".js-enter-visible-password", e => {
			const element = $(e.currentTarget);
			const input = element.parents(".enter__block").find(".enter__input");
			element.toggleClass("active");

			if (input.attr("type") === "text") {
				input.attr("type", "password");
				element.attr(
					"aria-label",
					"Show password as plain text. " +
						"Warning: this will display your password on the screen."
				);
			} else {
				input.attr("type", "text");
				element.attr("aria-label", "Hide password.");
			}
		});

		$.each($(".form-group input"), (i, item) => {
			const element = $(item);
			if (element.val()) {
				element.next().addClass("inactive");
			}
		});

		$(".form-group input").on("input", e => {
			const element = $(e.currentTarget);
			element.next().addClass("inactive");
			if (!element.val()) {
				element.next().removeClass("inactive");
			}
		});

		$(".form-group input").on("click", e => {
			const element = $(e.currentTarget);
			element.next().addClass("inactive");
		});

		$(".form-group input").on("blur", e => {
			const element = $(e.currentTarget);
			if (!element.val()) {
				element.next().removeClass("inactive");
			}
		});

		$('.checkbox_register input[type="checkbox"]').on("change", e => {
			const $element = $(e.currentTarget);
			const value = Number($element.val());
			if (value === 1) {
				$element.prev().val(0);
				$element.val(0);
			} else {
				$element.prev().val(1);
				$element.val(1);
				$(".js-fast-btn").removeClass("disabled");
			}
		});
	}

	setUpModalListeners() {
		$("#js-popup-modal .modal__close").on("click", () => {
			$("#js-popup-modal").removeClass("recovery");

			if (window.location.pathname.includes("event")) {
				window.location.assign("/");
			}
		});

		$(document).on("click", ".enter__close", () => {
			if (window.location.pathname.includes("event") && !helpers.isDesktop.matches) {
				window.location.assign("/");
			}
		});

		$(".js-enter-recovery").on("click", () => {
			$("#loginModal").modal("hide");
		});

		$(document).on("click", ".js-login-back", () => {
			$("#recoveryModal").modal("hide");
			$("#loginModal").modal("show");
		});

		$(".js-enter-register").on("click", () => {
			$("#loginModal").modal("hide");
			$("#accessModal").modal("hide");
		});

		$(".js-get-access-modal").on("click", e => {
			$("#loginModal").modal("hide");
			$("#registerModal").modal("hide");
			const initial = $(e.currentTarget).data("initial");
			$(".access-request__link").hide();
			$(`.access-request__link[data-initial="${initial}"]`).show();
		});

		$(".js-enter-login").on("click", () => {
			$("#registerModal").modal("hide");
			$("#fastRegisterModal").modal("hide");
			$("#accessModal").modal("hide");
			$("#js-popup-modal").modal("hide");
		});
	}

	setUpAccessListeners() {
		$(".js-sphere-item").on("click", e => {
			const element = $(e.currentTarget);
			const index = element.index() + 1;
			const selectedText = element.text();
			$("#requestadmin-activity_sphere")[0][index].selected = true;
			$("#js-dropdown-sphere").ariaDropdown("slideUp");
			$("#js-dropdown-sphere .dropdown__btn").find("span").text(selectedText);
		});

		$(".js-access-radio").on("change", e => {
			const element = $(e.currentTarget);
			const type = element.val();
			$(".js-access-content").hide();
			$(`.js-access-content[data-type='${type}']`).show();
		});

		$("#js-access-hide").on("click", () => {
			$("#js-access").slideUp();
			utils.setCookie("accessHide", true, { path: "/", "max-age": "36000000" });
		});

		$("#js-close-access").on("click", () => $("#js-access").slideUp());
	}

	initQuantityCounter() {
		$.each(
			$(".js-quantity-counter"),
			(i, quantityCounter) => new QuantityCounter(quantityCounter)
		);
	}

	initTicketReturn() {
		if (!$(".js-ticket-return").length > 0) return false;

		$(".js-ticket-return").on("click", e => {
			const $element = $(e.currentTarget);
			const orderId = $element.data("order");
			const eventId = $element.data("event");
			const fragment = document.importNode($("#js-template-refund")[0].content, true);
			const returnConfirm = $(fragment).find("#js-return-confirm");
			returnConfirm.data("order", orderId);
			returnConfirm.data("event", eventId);
			$("#js-popup-modal").find(".modal-body").html(fragment);
			$("#js-popup-modal").addClass("modal_refund");
			$("#js-popup-modal").modal();
		});

		$(document).on("click", "#js-return-confirm", e => {
			const $element = $(e.currentTarget);
			const orderId = $element.data("order");
			const eventId = $element.data("event");

			api.refund
				.refund({ orderId, eventId })
				.then(res => {
					if (!res.success) throw new Error(res.message);

					const fragment = document.importNode(
						$("#js-template-refund-success")[0].content,
						true
					);
					$("#js-popup-modal").find(".modal-body").html(fragment);
					$("#js-popup-modal").addClass("modal_refund-success");

					const $historyButtonsWrapper = $(
						`.js-ticket-return[data-event="${eventId}"][data-order="${orderId}"]`
					)
						.parent()
						.parent()
						.find(".history__buttons");

					$($historyButtonsWrapper).after(`
						<div class="order__was-refund">
	            <button class="order__was-refund-btn reset-btn">Билеты были возвращены</button>
	          </div>
					`);
					$($historyButtonsWrapper).remove();
					$("." + "js-ticket-return").remove();
				})
				.catch(err => {
					console.log(err);
					alert(`Произошла ошибка!\n${err.message || "Неизвестная ошибка с сервера!"}`);
				});
		});
	}

	initCheckUserByEmailInput() {
		$(".js-input-email-fast").on("change", e => {
			const element = $(e.currentTarget);
			const email = element.val();
			api.user.check({ email }).then(user => {
				const form = element.parents("form");
				const second = form.find(".js-fast-second")[0];
				const first = form.find(".js-fast-first")[0];
				const phone = form.find(".js-fast-phone")[0];
				second.value = user.second;
				first.value = user.first;
				phone.value = user.phone;
			});
		});
	}

	initFastRegistration() {
		$(document).on("click", ".js-get-fast-registration", e => {
			const el = $(e.currentTarget);
			e.preventDefault();
			$.each($("[data-toggle=tooltip]"), (i, item) => {
				$(item).tooltip("hide");
			});
			$("#fastRegisterModal").detach().appendTo("body").modal();
			const parent = el.parents(".js-order");
			const sum = el.parents(".js-order").find(".js-sum").text();
			const pkWarning = $(".js-pk-warning");

			if (el.hasClass("order__button_pushkin")) {
				pkWarning.show();
				if (!this.isDesktop.matches) {
					$("#js-popup-modal .modal-body").html(el.attr("data-original-title"));
					$("#js-popup-modal").addClass("modal_center show").removeClass("modal_event");
					$("#js-popup-modal").modal();
				}
			} else {
				pkWarning.hide();
			}
			$(".js-sum-fast").text(sum);
			let action = $("#fast-registration-controller").attr("action");
			const eventId = parent.find(".tickets.tickets_order").data("service");
			const resultID = action.match(/event_id=\d*/);
			action = action.replace(resultID, `event_id=${eventId}`);
			$("#fast-registration-controller").attr("action", action);
		});
	}

	initToggleActiveClass() {
		$(document).on("click", ".js-toggle-active", e => {
			const target = $(e.currentTarget).data("toggle-target");

			$(e.currentTarget).toggleClass("active");

			if (target) return $(target).toggleClass("active");
		});
	}

	initNews() {
		const swiper = new Swiper(".news-slider__container", {
			direction: "vertical",
			slidesPerView: 1,
			allowSlideNext: false,
			allowSlidePrev: false,
			allowTouchMove: false,
			observer: true,
			observeParents: true,
			observeSlideChildren: true,
			resizeObserver: true,
			navigation: {
				nextEl: ".news-slider__btn-next",
				prevEl: ".news-slider__btn-prev",
			},
			breakpoints: {
				1024: {
					watchOverflow: true,
					direction: "horizontal",
					autoHeight: true,
					allowSlideNext: true,
					allowSlidePrev: true,
				},
			},
		});

		const newsBtnMobile = document.querySelector(".news-slider__btn-mobile");

		swiper.on("beforeResize", () => {
			swiper.update();
		});

		newsBtnMobile &&
			newsBtnMobile.addEventListener("click", () => {
				const allNews = document.querySelectorAll(".swiper-slide");
				const newsSlider = document.querySelector(".news-slider");
				const swiperContainer = document.querySelector(".swiper-container");
				const newsText = document.querySelectorAll(".news-slider__text p");
				const sliderWrapper = document.querySelectorAll(".news-slider__wrapper");

				if (!newsBtnMobile.classList.contains("news-slider__btn-mobile_active")) {
					swiper.params.slidesPerView = allNews.length;
					newsBtnMobile.classList.add("news-slider__btn-mobile_active");
					newsSlider.style.marginBottom = "15px";
					sliderWrapper.forEach(slide => {
						slide.classList.add("news-slider__wrapper_active");
						slide.style.cssText = `
								align-items: start;
								margin: 15px 0;
							`;
					});
					swiperContainer.style.height = "auto";
					newsText.forEach(text => (text.style.cssText = `display: inline!important;`));
				} else {
					swiper.params.slidesPerView = 1;
					newsBtnMobile.classList.remove("news-slider__btn-mobile_active");
					newsSlider.style.marginBottom = "0";
					sliderWrapper.forEach(slide => {
						slide.classList.remove("news-slider__wrapper_active");
						slide.style.cssText = `
								align-items: center;
								margin: 0;
								max-height: 50px!important;
							`;
					});
					swiperContainer.style.height = "50px";
					newsText.forEach(
						text => (text.style.cssText = `display: -webkit-box!important;`)
					);
				}
				swiper.update();
			});
	}
}
